import React from 'react';
import WelcomeImage from "../../assets/Deeze/welcome.png";
import { useLocalStorage } from '../../services';
import { useSelector } from 'react-redux';
import Lottie from 'lottie-react'
import systemAnimation from "../../assets/Deeze/system.json"
const MainContent = () => {

  

  
  const theme = useSelector((state)=> state.general.lightMode)



  

  return (
    <div className={`${ theme ? 'bg-white' : 'bg-[#172554]' } h-[90vh] lg:h-[75vh] flex flex-col lg:flex-row justify-center select-none items-center`}>
      <div className='flex flex-col py-10 lg:px-10 lg:w-2/6 mx-10'>
        <h1 className={`${theme  ? 'text-[#172554]' : 'text-white'} tracking-tighter text-3xl lg:text-6xl poppins-bold select-none `}>Better Solution for your business</h1>
        
        
        <p className={`${theme  ? 'text-[#172554]' : 'text-white'} select-non py-4 text-lg`}>We are a team of experienced designers and developers committed to delivering cutting-edge solutions for web development projects. With a passion for innovation, we strive to create captivating and user-friendly websites that exceed client expectations.</p>
        <div className='flex flex-row my-5 gap-8'>
          <button className="bg-[#247EAB] poppins-regular hover:bg-blue-700 transition duration-300 ease-in-out text-white font-bold select-none py-2 px-4 rounded-3xl">
            Get Started
          </button>
          <button className={`${theme  ? 'border-[#247EAB] border-[1px]  ': 'bg-white'} poppins-regular text-[#247EAB] font-bold py-2 px-4 rounded-3xl`}>
            Learn More
          </button>
          
        </div>
      </div>

     
      <div className="hidden md:block justify-center w-2/6   ">
        <Lottie loop={false} animationData={systemAnimation}/>
        
      </div>

      <div className="lg:hidden justify-center w-5/6 pb-5   ">
        <Lottie loop={false} animationData={systemAnimation}/>
        
      </div>
    </div>
  );
}

export default MainContent;

